import getIframeDocument from '@newswebsiteapp/shared/lib/getIframeDocument'

import { newsletterIframeLoadedObservable } from './observables'

newsletterIframeLoadedObservable.subscribe((iframe) => {
  // add custom styles to iframe //
  const style = document.createElement('style')

  style.type = 'text/css'

  // center newsletters like https://newswebsite.com/newsletters/bulletin-star-wars-whites-getting-message-disney-doesnt-want-them-etc-79-items
  const stylesForOldNewslettergs = `
    body > table {
      margin-left: auto;
      margin-right: auto;
    }
  `

  const nightmodeStyles = `
    body.nightmode > div {
      background-color: #222 !important;
    }

    body.nightmode * {
      color: #00BC8C !important;
    }

    body.nightmode .white_color {
      color: white !important;
    }

    body.nightmode .orange_background {
      background-color: #f57a12 !important;
    }
  `

  style.innerHTML = stylesForOldNewslettergs + nightmodeStyles

  getIframeDocument(iframe).head.appendChild(style)

  // hack to make buttons have white text on new newsletters (like https://newswebsite.com/newsletters/july-2-2018) //
  const { body } = getIframeDocument(iframe)
  const body$ = $(body)

  // donation buttons
  body$.find('a:contains("DONATE")').addClass('white_color')

  // see other buttons
  const seeOtherRegex = /SEE OTHER/g

  const seeOtherButtons = body$.find('a').filter(function () {
    return seeOtherRegex.test($(this).text())
  })

  seeOtherButtons.addClass('white_color')
  seeOtherButtons.addClass('orange_background')
  seeOtherButtons.parent().addClass('orange_background')
})
